






import { Component, Watch, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { ListType } from '@/util/types'
import { courseItem, resourceItem } from '@/api/res'
import { parse } from 'qs'
const echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/bar')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')

@Component({
  components: {}
})
export default class ClassUseTime extends ViewBase {
  @Prop({ default: null }) pointsUseTime!: any

  lang: any = {}

  echartSource: any = []
  // 鼠标指到柱状图上的提示文字
  textArr: any = []

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  get isEnLang() {
    return this.$i18n.locale == 'en'
  }

  setSource() {
    const pointsUseTime = this.pointsUseTime
    const arr = []
    const textArr = []
    let index = 0
    for (const key of Object.keys(pointsUseTime)) {
      // 鼠标指上去的提示文字
      const textObj: any = {
        max: {},
        min: {},
        avg: {}
      }
      // echarts绘制对象
      const obj: any = {}
      obj.product = pointsUseTime[key].k_name
      obj.max = pointsUseTime[key].max.num
      obj.min = pointsUseTime[key].min.num
      obj.avg = pointsUseTime[key].avg.num
      obj.index = index++
      arr.push(obj)
      textObj.max.text = pointsUseTime[key].max.cid_name_list
      textObj.max.num = pointsUseTime[key].max.num
      textObj.min.text = pointsUseTime[key].min.cid_name_list
      textObj.min.num = pointsUseTime[key].min.num
      textObj.avg.text = pointsUseTime[key].avg.cid_name_list
      textObj.avg.num = pointsUseTime[key].avg.num
      textArr.push(textObj)
      this.textArr = textArr
      this.echartSource = arr
    }
    this.setUseTime()
  }

  // 各考点用时统计
  setUseTime() {
    const that = this
    const myChart = echarts.init(this.$refs.useTime)
    const option = {
      legend: {
        x: 'center'
      },
      tooltip: {
        trigger: 'item' /*此处为item*/,
        axisPointer: {
          type: 'line'
        },
        formatter(params: any, trigger: any) {
          const index = params.value.index
          const textKey = params.dimensionNames[params.encode.y[0]]
          return `<div style="text-align:center">${that.textArr[index][textKey].text},${that.textArr[index][textKey].num}${that.lang.minute}</div>`
        }
      },
      dataset: {
        dimensions: ['product', 'max', 'min', 'avg'],
        source: that.echartSource
      },
      xAxis: {
        type: 'category',
        name: that.lang.xAxisText,
        nameLocation: 'center',
        nameTextStyle: { padding: 10 }
      },
      yAxis: { name: that.lang.minute, nameLocation: 'end' },
      // Declare several bar series, each will be mapped
      // to a column of dataset.source by default.
      series: [
        {
          barGap: 0,
          name: that.lang.maxTime,
          type: 'bar',
          itemStyle: {
            normal: {
              color: '#5B9BD5'
            }
          }
        },
        {
          name: that.lang.minTime,
          type: 'bar',
          itemStyle: {
            normal: {
              color: '#ED7D31'
            }
          }
        },
        {
          name: that.lang.averageTime,
          type: 'bar',
          itemStyle: {
            normal: {
              color: '#A5A5A5'
            }
          }
        }
      ]
    }

    // 绘制图表
    myChart.setOption(option)
  }

  created() {
    this.lang = this.i18n.vStudy
    setTimeout(() => {
      this.setSource()
    })
  }
}
